import { Component, Input } from '@angular/core';
import { ContentWidgetDto, EContentWidgetType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
    selector: 'app-widget-base',
    template: '',
    standalone: false
})
export class WidgetBaseComponent {
  @Input() public widget?: ContentWidgetDto | undefined;

  public eContentWidgetType: typeof EContentWidgetType;

  public constructor() {
    this.eContentWidgetType = EContentWidgetType;
  }
}
